<i *ngIf="iconName !== IconType.None" [ngClass]="['d-flex', iconName]" [attr.title]="tooltip" [style.font-size]="iconSize"></i>
